export enum TicketStatus {
  new = "new",
  open = "open",
  pending = "pending",
  hold = "hold",
  solved = "solved",
  closed = "closed",
}

export enum TicketPriority {
  p1 = "p1_critical_system_outage",
  p2 = "p2_degraded_service",
  p3 = "p3_general_issue",
}

export interface Attachment {
  name: string;
  url: string;
  type: string;
}
